var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "passenger-picker-container" },
    [
      _c("f9input2", {
        staticClass: "passenger-picker-input",
        attrs: {
          placeholder: _vm.travelerInputString,
          "aria-expanded": _vm.expanded ? "true" : "false",
          type: "text",
          readonly: ""
        },
        nativeOn: {
          click: function($event) {
            _vm.expanded = true
          },
          keypress: function($event) {
            if (
              !("button" in $event) &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            _vm.expanded = true
          }
        }
      }),
      _vm._v(" "),
      _c("span", {
        staticClass: "select-arrow",
        class: _vm.expanded ? "flip180" : "unflip180"
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "dropdown",
          staticClass: "dropdown",
          class: { hide: !_vm.expanded }
        },
        [
          _c("f9passenger-picker-accordion", {
            attrs: {
              accordionLabel: "Adults",
              canAddPassengers: _vm.canAddAdults,
              minimumNumberOfPassengersByType: 1,
              buildTravelersText: _vm.buildTravelerText,
              onRemove: _vm.onRemove
            },
            on: { input: _vm.emitInput },
            model: {
              value: _vm.passengersObject.adults,
              callback: function($$v) {
                _vm.$set(_vm.passengersObject, "adults", $$v)
              },
              expression: "passengersObject.adults"
            }
          }),
          _vm._v(" "),
          _c("f9passenger-picker-accordion", {
            attrs: {
              accordionLabel: "Lap Infants",
              accordionSubLabel: "(Under 2)",
              canAddPassengers: _vm.canAddLapInfants,
              buildTravelersText: _vm.buildTravelerText
            },
            on: { input: _vm.emitInput },
            model: {
              value: _vm.passengersObject.infants,
              callback: function($$v) {
                _vm.$set(_vm.passengersObject, "infants", $$v)
              },
              expression: "passengersObject.infants"
            }
          }),
          _vm._v(" "),
          _c("f9passenger-picker-accordion", {
            attrs: {
              accordionLabel: "Children",
              accordionSubLabel: "(Under 15)",
              canAddPassengers: _vm.canAddChildren,
              buildTravelersText: _vm.buildTravelerText
            },
            on: { input: _vm.emitInput },
            model: {
              value: _vm.passengersObject.children,
              callback: function($$v) {
                _vm.$set(_vm.passengersObject, "children", $$v)
              },
              expression: "passengersObject.children"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "traveler-bkg",
        class: { hide: !_vm.expanded },
        on: {
          click: function($event) {
            $event.stopPropagation()
            $event.preventDefault()
            _vm.expanded = false
          }
        }
      }),
      _vm._v(" "),
      _c("span", { attrs: { id: "traveler-text", "aria-live": "polite" } }, [
        _vm._v(_vm._s(_vm.travelerText))
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34f338c3", { render: render, staticRenderFns: staticRenderFns })
  }
}